function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "iconfinder_01_111032",
  d: "M31.949,49.733a1.616,1.616,0,0,0,1.617,1.617H49.732a1.616,1.616,0,0,0,1.617-1.617V33.567a1.616,1.616,0,0,0-1.617-1.617H33.566a1.616,1.616,0,0,0-1.617,1.617V49.733Zm10.1-.808V42.458H40.436V40.033h1.617c0-4.167.178-4.446,5.254-4.446v2.425c-2.676,0-2.425.15-2.425,2.021h2.425v2.425H44.882v6.467H42.053Z",
  transform: "translate(-31.949 -31.95)",
  fill: "#f50b0b",
  fillRule: "evenodd"
});

var SvgFace = function SvgFace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.399,
    height: 19.399,
    viewBox: "0 0 19.399 19.399",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/face.4c5dea5f.svg";
export { ForwardRef as ReactComponent };